import React, { useEffect, useState } from 'react'
import jwt_decode from "jwt-decode";
import { REQUEST_TARGET_MODULES } from '../../../Library/APIsTarget';
import LoadingBtn from '../../Widgets/LoadingBtn';
import { AlertNotif } from '../../../Library/AlertNotif';
import CardProfilePCF from '../Reregistration-New/Components/CardProfilePCF';
import TableCurriculums from './TableCurriculums';

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export function MCurriculum() {
    const studentid = AuthDecode.currentData.entityid.toString();
    const [student_status, setStundent_status] = useState({ loading: false, data: [], message: "" });
    const [student_bio, setStundent_bio] = useState({ loading: false, data: [], message: "" });
    const ReloadStudentStatus = async () => {
        setStundent_status({ loading: true, data: [], message: "" })
        const param_post = {
            parameters: { studentid },
            target_data: "GET_STUDENT_STATUS",
        }

        const results = await REQUEST_TARGET_MODULES(param_post);
        setStundent_status(results);
    }
    const ReloadStudentBio = async () => {
        setStundent_bio({ loading: true, data: [], message: "" })
        const param_post = {
            parameters: { studentid },
            target_data: "GET_STUDENT_DATA_M",
        }

        const results = await REQUEST_TARGET_MODULES(param_post);
        setStundent_bio(results);
    }
    useEffect(()=>{
        ReloadStudentStatus();
        ReloadStudentBio();
    },[studentid]);

    return student_status.loading || student_bio.loading ? <LoadingBtn /> :
    student_status.message || student_bio.message ? <AlertNotif message={student_status.message || student_bio.message} color="danger" /> :
    Object.values(student_status.data).length > 0 || Object.values(student_bio.data).length > 0 ? (
        <div>
            <CardProfilePCF studentid={studentid} student_status={student_status.data} student_bio={student_bio.data} />
            <TableCurriculums param={{clu_id:student_status.data?.clu?.id || 0, clu_spec_id:student_status.data?.clu_spec?.id || 0,curr_id:student_status.data?.curr?.id || 0,studentid:studentid}} />
        </div>
    ):"";
}
